import React from 'react';
import ReactDOM from 'react-dom';

import Nav from './Nav';

const reactNavContainer = document.querySelector('#react-nav');
ReactDOM.render(<Nav />, reactNavContainer);
